/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import {
  accessAPI,
  Boton,
  Titulo,
  Formulario,
  Sidebar,
  useFuncionalidad,
  TablaFiltrable
} from "../../../../shared";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";

export default function TarjetaAsignarEsquema({
  esquemas: esquemasProp,
  certificadoTipoId
}) {
  const conUrsea = useFuncionalidad("URSEA");
  const [esquemas, setEsquemas] = useState(esquemasProp);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [loaderAgregar, setLoaderAgregar] = useState(false);
  const toast = useRef(null);

  function agregarEsquema(datosFormulario) {
    setLoaderAgregar(true);
    accessAPI(
      "PUT",
      `admin/config/certificadotipo/${certificadoTipoId}/esquema`,
      datosFormulario,
      (respuesta) => {
        setEsquemas((prev) => [...prev, respuesta]);
        setSidebarVisible(false);
        setLoaderAgregar(false);
        toast.current?.show({
          severity: "success",
          summary: "Agregado",
          detail: "Esquema agregado exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al agregar el esquema",
          sticky: true
        });
        setLoaderAgregar(false);
      }
    );
  }

  function eliminarEsquema(esquema) {
    accessAPI(
      "DELETE",
      `admin/config/certificadotipo/${certificadoTipoId}/esquema`,
      { esquemaid: esquema.esquema.id },
      () => {
        setEsquemas((prev) => prev.filter((e) => e.id !== esquema.id));
        toast.current?.show({
          severity: "success",
          summary: "Eliminado",
          detail: "Esquema eliminado exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar el esquema",
          sticky: true
        });
      }
    );
  }

  const agregarFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "esquemaid",
            tipoitemformularioid: 5,
            etiqueta: "Esquema",
            opciones: "admin/config/esquema?mostrarnombre=true",
            sinOpcionInicial: true,
            requerido: true
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Agregar esquema", callback: agregarEsquema, validar: true }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Card>
        <Titulo
          botones={
            <Boton icono negro callback={() => setSidebarVisible(true)}>
              <i className="pi pi-plus" />
            </Boton>
          }
        >
          Esquemas
        </Titulo>
        <TablaFiltrable conFiltros={false}
          value={esquemas}
          nombreArchivo="esquemas_tipo_certificado"
          emptyMessage="No hay esquemas asignados"
        >
          <Column field="esquema.etiqueta" header="Etiqueta" />
          {/* El nombre en URSEA: sin la integración la columna quedaría vacía. */}
          {conUrsea && <Column field="esquema.nombre" header="Nombre" />}
          <Column
            body={(rowData) => (
              <Boton
                icono
                rojo
                chico
                confirmacion="¿Eliminar este esquema?"
                callback={() => eliminarEsquema(rowData)}
              >
                <i className="pi pi-trash" />
              </Boton>
            )}
            style={{ width: "3rem", textAlign: "center" }}
          />
        </TablaFiltrable>
      </Card>

      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Agregar esquema</Titulo>
        <Formulario
          config={agregarFormConfig}
          loader={loaderAgregar}
          key={esquemas.length}
        />
      </Sidebar>
    </>
  );
}
